import React, { Suspense } from 'react';
import { MarketManagers } from 'components/context/market_managers';
import { OrderDetails } from 'components/context/order_details';
import { FeatureFlags } from 'components/context/feature_flags';
import PageLoader from 'components/common/page_loader';
import Cart from 'components/pages/cart/cart';
import ShopTheme from 'theme/shop_theme';
import DashboardModeCompatiblePage from 'components/common/dashboard_mode_compatible_page';
import { BrowserRouter } from 'react-router-dom';
// eslint-disable-next-line import/no-unassigned-import
import 'utilities/i18n';
import { datadogRum } from '@datadog/browser-rum';
import ShopErrorBoundary from 'typescript/components/shop_error_boundary';

const CartApp = (props) => {
  // Set additional global context for Datadog RUM
  datadogRum.setGlobalContext(props.rumAttributes || {});

  return (
    <ShopTheme>
      <ShopErrorBoundary appName="cart">
        <Suspense fallback={<PageLoader delayMs={500} />}>
          <MarketManagers>
            <FeatureFlags {...props}>
              <OrderDetails {...props}>
                <BrowserRouter>
                  <DashboardModeCompatiblePage>
                    <Cart />
                  </DashboardModeCompatiblePage>
                </BrowserRouter>
              </OrderDetails>
            </FeatureFlags>
          </MarketManagers>
        </Suspense>
      </ShopErrorBoundary>
    </ShopTheme>
  );
};

export default CartApp;
